import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { captureException } from '@sentry/node';

import { doRequest } from '@r1-frontend/do-request';
import { IPayResponse, pay } from '@r1-frontend/api-domru/api-loyalty/v1/program/pay';

import { TState } from '~/src/store';
import { getClientAll } from '~/src/store/actions/auth/getClientAll';
import selectProviderId from '~/src/store/selectors/selectProviderId';

export const useSendPayBonuses = () => {
    const dispatch = useDispatch();

    const { bonusesValue } = useSelector((state: TState) => state.payment.paymentData);
    const providerId = useSelector(selectProviderId);

    return useCallback(async() => {
        try {
            const resp = await doRequest.apiLoyalty<IPayResponse>(
                pay(providerId, { bonusValue: bonusesValue }),
            );
            if (resp.isSuccess) {
                dispatch(getClientAll()); // TODO дополнительная ответвтвенность, вынести в основной код
            }

            return resp;
        } catch (error) {
            captureException(error);
        }
    }, [providerId, bonusesValue, dispatch]);
};
